export const joinUrl = (...partials: Array<string | number | undefined | null>): string => {
    const notEmpty = partials.filter(Boolean)
    if (notEmpty.length) {
        const trimmed = notEmpty.map((element) => {
            const el = String(element).replace(/^\//, '')
            return el.replace(/\/$/, '')
        })
        return `/${trimmed.filter(Boolean).join('/')}`
    }
    return ''
}

export default joinUrl
